<template>
  <div class="textField">
    <p class="textFieldCaption">
      <span v-html="surveyQuestion.longCaption" />
    </p>
    <textarea
      ref="textarea"
      class="w-full textArea p-3"
      maxlength="400"
      v-model="inputValue"
      :placeholder="texts.textarea_placeholder"
      @input="onInput(inputValue)"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers('survey')

export default {
  name: 'TextField',
  data() {
    return {
      inputValue: '',
    }
  },
  computed: {
    ...mapGetters(['surveyQuestion', 'texts']),
  },
  created() {
    this.setInputName(this.surveyQuestion.inputName)
    this.$emit('setValid', this.inputValue.length > 0)
  },
  methods: {
    ...mapActions(['setInputName', 'setAnswer']),
    onInput(value) {
      this.setAnswer(value)
      this.$emit('setValid', this.inputValue.length > 0)
    },
  },
}
</script>

<style scoped lang="postcss">
@media (max-width: 768px) {
  .textArea {
    height: 113px;
  }
  /deep/.textFieldCaption {
    padding-bottom: 5px;
    font-size: 16px;
  }
}

@media (min-width: 768px) {
  .textArea {
    height: 200px;
  }
  /deep/ .textFieldCaption {
    padding-bottom: 54px;
    font-size: 25px;
  }
}

.textFieldCaption {
  text-align: left;
  line-height: 1.2;
  letter-spacing: normal;
  color: #191919;
}

.textArea {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  width: 100%;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #191919;
  background-color: #f3f2f0;
  font-size: 16px;
  line-height: 20px;
  resize: none;

  &:focus {
    outline: 0;
  }
}
</style>
